export default __webpack_public_path__ + "static/media/football.4050d7cb.png";